<div class="py-2 px-2 py-md-5 px-md-5">
    <div class="row">
        <div class="col-md-6">
            <mat-card class="bg-white mat-elevation-z3">
                <div class="row">
                    <div class="col-md-6">
                        <mat-card-header>
                            <mat-card-title>
                                <mat-icon class="mx-1" color="primary">task</mat-icon>
                                Dodanie zadania
                            </mat-card-title>
                            <mat-card-subtitle>Opisz i dodaj zadanie.</mat-card-subtitle>
                        </mat-card-header>
                    </div>
                </div>
                <mat-card-content>
                    <div class="pt-2">
                        <app-task-form #data></app-task-form>
                        <app-form-save-button [invalid]="isSaved || data.taskForm.invalid"
                                              (closeForm)="closeForm()"
                                              (save)="addTask()"></app-form-save-button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
